import React from 'react'
import * as classes from './Timeline.module.scss'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'

function Timeline({ data, lang }) {
    const title = data?.timeline?.value ? deleteHtmlTag(data.timeline.value, 'p') : ''
    const photoUrl = data?.timeline?.photo?.url
    const photoAlt = data?.timeline?.photo?.alt || title

    if (!title && !photoUrl) {
        return null
    }

    return (
        <section className={classes.Section}>
            <Container>
                {title ? <SectionTitle title={title} lang={lang} /> : null}

                {photoUrl ? (
                    <div className={classes.ImageWrap}>
                        <img className={classes.Image} src={photoUrl} alt={photoAlt} />
                    </div>
                ) : null}
            </Container>
        </section>
    )
}

export default Timeline
